import { createSelector } from 'reselect';
import { State } from 'reducers';
import { HasDeviceId } from './buildingsSelectors';

//
//  Note: A device can have 0 or 1 schedules and a schedule always has exactly one device.
//        So there is no Schedule ID proper. Instead, we use the Device ID to index schedules.
//        (But note the schedules table in the database is actually the rules and each rule
//        does have an id)
//

const getSchedulesState =
    (state: State) =>
        state.schedules;

export const getSchedules =
    createSelector(getSchedulesState,
        state => state.data
    );

const getDeviceId = (state: State, { deviceId }: Partial<HasDeviceId>) => deviceId;
export const getScheduleForDevice =
    createSelector(
        getSchedules,
        getDeviceId,
        (schedules, deviceId) => (deviceId && schedules[deviceId]) || null
    );
